import { render, staticRenderFns } from "./SubscriptionPopoverItem.vue?vue&type=template&id=49844eb6&"
import script from "./SubscriptionPopoverItem.vue?vue&type=script&lang=js&"
export * from "./SubscriptionPopoverItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports